// extracted by mini-css-extract-plugin
export default {"rewardImage":"OnlineRewardModal_rewardImage__NraTK"};